<template>
<div class="chapter">
<div class="inner_page">
<p class="block_4">A</p>
<p class="block_4">SECOND</p>
<p class="block_4">HAND</p>
<p class="block_4">LIE</p>
<p class="block_2"> </p>
<p class="block_5">A Short Story Thriller</p>
<p class="block_"> </p>
<h3 class="block_6">Pamela Crane</h3>
<p class="block_2"> </p>
<p class="block_2"> </p>
<p class="block_7">Tabella House</p>
<p class="block_7">Raleigh, North Carolina</p>
<p class="block_"> </p>
<p class="block_8" id="calibre_pb_1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?34919aac